import { render, staticRenderFns } from "./lio.vue?vue&type=template&id=e6f643ca&scoped=true&"
import script from "./lio.vue?vue&type=script&lang=js&"
export * from "./lio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f643ca",
  null
  
)

export default component.exports